import { BodyShort01, ProductiveHeading05 } from 'module/ui/components/styles';
import { FC } from 'react';
import styled from 'styled-components';
import { OzoneDrawerProps } from './ozone-drawer';

const Container = styled.div<{ subTitlePlacement?: string }>`
  background-color: var(--coolest-gray-10);
  padding: var(--spacing-05) var(--spacing-06);
  border-bottom: none;
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  flex-direction: ${(props) =>
    props.subTitlePlacement === 'top' ? 'column-reverse' : 'column'};
  gap: var(--spacing-02);
`;

const Title = styled.h5`
  ${ProductiveHeading05};
  margin-bottom: 0;
`;

const SubTitle = styled.div<{ subTitleColor?: string }>`
  ${BodyShort01};
  color: ${(props) => props.subTitleColor};
`;

export const Header: FC<
  Pick<
    OzoneDrawerProps,
    'title' | 'subTitle' | 'subTitleColor' | 'subTitlePlacement'
  >
> = ({ title, subTitle, subTitleColor, subTitlePlacement }) => (
  <Container subTitlePlacement={subTitlePlacement}>
    {title ? <Title>{title}</Title> : null}
    {subTitle ? (
      <SubTitle subTitleColor={subTitleColor}>{subTitle}</SubTitle>
    ) : null}
  </Container>
);
